import React from "react";
import { useI18n } from "@/i18n";
import { Check } from "lucide-react";

export default function LanguageSwitcher({ dark = false }) {
  const { lang, setLang } = useI18n();
  const langs = [{ c: "fr", l: "FR" }, { c: "en", l: "EN" }];
  return (
    <div className="flex items-center gap-1" data-testid="language-switcher">
      {langs.map((x, i) => (
        <React.Fragment key={x.c}>
          {i > 0 && <span className={dark ? "text-white/40" : "text-nj-muted/50"}>·</span>}
          <button
            data-testid={`lang-${x.c}`}
            onClick={() => setLang(x.c)}
            className={`text-sm font-semibold tracking-wide transition-colors ${
              lang === x.c
                ? dark ? "text-white" : "text-nj-primary"
                : dark ? "text-white/60 hover:text-white" : "text-nj-muted hover:text-nj-primary"
            }`}
          >
            {lang === x.c && <Check className="inline w-3 h-3 mr-0.5" />}
            {x.l}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
}
